import React, { useState, useEffect, FunctionComponent } from 'react';
import { Presentation } from './presentation';
import type { CompanyDetailRecruitmentsProps as Props } from './types';
import { getCompanyRecruitments } from '../../../services/companies';

export const Component: FunctionComponent<Props> = (props) => {
  const [recruitmentIds, setRecruitmentIds] = useState<number[]>([]);

  useEffect(() => {
    const fetchRecruitments = async () => {
      try {
        const response = await getCompanyRecruitments(props.company.id)
        setRecruitmentIds(response.recruitmentIds ?? []);
        props.setIdCount('recruitmentIds', (response.recruitmentIds ?? []).length);
      } catch (error) {
        console.log(error);
        setRecruitmentIds([]);
        props.setIdCount('recruitmentIds', 0);
      }
    };
    fetchRecruitments();
  }, [props.company.id, props.setIdCount]);

  return (
    <Presentation
      recruitmentIds={recruitmentIds}
      company={props.company}
      coverNoImg={props.coverNoImg}
      dataCategory={props.dataCategory}
      dataValue={props.dataValue}
    />
  );
};
